import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { DataBaseOrderServicePlan } from 'src/app/models/database_order_service_plan.model';
import { OrderServicePlan } from 'src/app/models/order_service_plan.model';
import { ServicePlan } from 'src/app/models/service_plan.model';
import { OrderService } from 'src/app/services/order.service';
import { OrderServicePlanService } from 'src/app/services/order_service_plan.service';
import { PaymentService } from 'src/app/services/payment.service';
import { ServiceProviderService } from 'src/app/services/service-provider.service';
import { ShoppingService } from 'src/app/services/shopping.service';
import { TokenStorageService } from 'src/app/services/token_storage.service';
import { UserService } from 'src/app/services/user_service.service';
import { AddItemAction } from 'src/app/store/actions/shopping.actions';
import { AppState } from 'src/app/store/models/app-state.model';
import { ShoppingItem } from 'src/app/store/models/shopping-item.model';
import { MyErrorStateMatcher } from '../shopping/error-state-matcher';
import { MatProgressBar } from "@angular/material/progress-bar";
import { MatDivider } from "@angular/material/divider";
import { MatIcon } from "@angular/material/icon";
import { MatLabel, MatFormField, MatSelect, MatError, MatOption } from "@angular/material/select";
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';

@Component({
	selector: 'app-product-view',
	templateUrl: './product-view.component.html',
	styleUrls: ['./product-view.component.scss'],
 imports: [MatProgressBar, MatDivider, MatIcon, MatLabel, MatFormField, MatSelect, MatError, MatOption, ReactiveFormsModule, MatInputModule, MatButtonModule, MatCheckboxModule]
})
export class ProductViewComponent implements OnInit {
	loading: boolean = false;
	servicePlanId: string = '';
	matcher = new MyErrorStateMatcher();
	selectedServicePlan!: ServicePlan;
	subOutOfStock: boolean = false;
	message: string = '';
	profileImage: string = '';
	termsLink!: string;

	addToCartFormGroup: FormGroup = new FormGroup({
		quantitySelect: new FormControl(1),
		appointmentTypeSelect: new FormControl(Validators.required),
	});

	agreeToTermsForm: FormControl = new FormControl(false);


	availableAppointmentTypes: string[] = [];

	constructor(
		private activatedRoute: ActivatedRoute,
		private router: Router,
		private store: Store<AppState>,
		private tokenService: TokenStorageService,
		private userService: UserService,
		private orderService: OrderService,
		private orderServicePlanService: OrderServicePlanService,
		private shoppingService: ShoppingService,
		private paymentService: PaymentService,
		private serviceProviderService: ServiceProviderService,
		private snackBar: MatSnackBar
	) { }

	ngOnInit() {
		localStorage.setItem('ReturnToProductView', 'false');
		localStorage.setItem('ProductId', '');
		this.loading = true;
		this.servicePlanId = this.activatedRoute.snapshot.paramMap.get('id') || '';
		this.shoppingService.getShoppingServicePlanById([this.servicePlanId]).subscribe((servicePlan: ServicePlan) => {
			this.selectedServicePlan = servicePlan;
			this.populateAvailableAppointments();
			if (this.selectedServicePlan.unlimitedQuantity) {
				this.addToCartFormGroup.controls.quantitySelect.setValidators([Validators.min(1), Validators.required])
			} else {
				this.addToCartFormGroup.controls.quantitySelect.setValidators([Validators.min(1), Validators.max(this.selectedServicePlan.quantityAvailable), Validators.required])
			}
			this.getProfileImage();
			this.userService.get(['Terms'], new Map).subscribe((result) => {
				this.termsLink = result.link;
			});
			this.loading = false;
		}, () => this.loading = false)
		if (this.servicePlanId.length != 36) {
			this.router.navigate(['/home']);
		}
	}

	addToCart(servicePlan: ServicePlan): void {
		this.loading = true;
		let item: ShoppingItem = {
			id: servicePlan.servicePlanId,
			quantity: this.addToCartFormGroup.controls.quantitySelect.value,
			appointmentLocation: this.addToCartFormGroup.controls.appointmentTypeSelect.value,
		}

		this.store.dispatch(new AddItemAction(item));
		this.snackBar.open("Added Service to Cart", 'Close', {
			horizontalPosition: 'center',
			verticalPosition: 'bottom',
			duration: 3000,
			panelClass: ['success-snack-bar'],
		  });


		if (this.tokenService.getToken() != null) {
			const queryParams = new Map([
				["userId", this.tokenService.getUser().id],
				["status", 'pending'],
			]);

			this.orderService.get([], queryParams).subscribe((result) => {
				const orderId: string = result[0].orderId;
				const matchingServicePlanArray = result[0].orderServicePlanModel.filter((x: OrderServicePlan) => x.servicePlanId.toLocaleUpperCase() == servicePlan.servicePlanId.toLocaleUpperCase()
					&& x.appointmentLocation.toLowerCase() == this.addToCartFormGroup.controls.appointmentTypeSelect.value.toLowerCase());

				if (matchingServicePlanArray.length > 0) {
					const updateOrderServicePlanId = matchingServicePlanArray[0].orderServicePlanId;

					matchingServicePlanArray.forEach((orderServicePlan: OrderServicePlan) => {
						let newTotal = 0;
						newTotal += orderServicePlan.quantity;
						newTotal += this.addToCartFormGroup.controls.quantitySelect.value;
						const updatedOrderServicePlan: DataBaseOrderServicePlan = {
							orderId: orderId,
							servicePlanId: servicePlan.servicePlanId,
							quantity: newTotal,
							appointmentLocation: this.addToCartFormGroup.controls.appointmentTypeSelect.value,
						}
						this.orderServicePlanService.put([updateOrderServicePlanId], updatedOrderServicePlan).subscribe();
					});

				} else {

					const orderServicePlan: DataBaseOrderServicePlan = {
						orderId: orderId,
						servicePlanId: servicePlan.servicePlanId,
						quantity: this.addToCartFormGroup.controls.quantitySelect.value,
						appointmentLocation: this.addToCartFormGroup.controls.appointmentTypeSelect.value,
					}
					this.orderServicePlanService.post([], orderServicePlan).subscribe();
				}
			});
		}
		this.loading = false;
	}

	populateAvailableAppointments(): void {
		if (this.selectedServicePlan?.virtualAvailability) {
			this.availableAppointmentTypes.push('Virtual');
		}

		if (this.selectedServicePlan?.inOfficeAvailability) {
			this.availableAppointmentTypes.push('In Office');
		}

		if (this.selectedServicePlan?.homeCareAvailability) {
			this.availableAppointmentTypes.push('Home Care')
		}
	}

	selectAppointmentType(appointmentType: any): void {
		this.addToCartFormGroup.controls.appointmentTypeSelect.setValue(appointmentType.value);
	}

	get isUserLoggedIn(): boolean {
		if (this.tokenService.getUser() != null && this.tokenService.getToken() != null) {
			return true;
		}
		return false;
	}

	routeToLogin(): void {
		localStorage.setItem('ReturnToCheckout', 'false');
		localStorage.setItem('ReturnToProductView', 'true');
		localStorage.setItem('ProductId', this.selectedServicePlan?.servicePlanId)
		this.router.navigate(['login']);
	}

	routeToStripePayment(): void {
		const emptyMap = new Map();
		const queryParams = new Map([
			["userId", this.tokenService.getUser().id],
			["servicePlanId", this.selectedServicePlan.servicePlanId],
			["appointmentLocation", this.addToCartFormGroup.controls['appointmentTypeSelect'].value]
		]);
		this.paymentService.get(['SubscriptionCheck', this.selectedServicePlan.servicePlanId], emptyMap).subscribe((result: boolean) => {
			if (result) {
				this.paymentService.get(['subscription'], queryParams).subscribe((stripeURL) => {
					window.location.href = stripeURL.model.stripeSessionUrl;
				}, (error) => this.message = error);
			} else {
				this.subOutOfStock = true;
			}
		})
	}

	navigateToProfilePage(): void {
		this.router.navigate([`Provider-Profile/${this.selectedServicePlan?.serviceProviderModel?.serviceProviderId}`]);
	}

	getProfileImage(): void {
		const serviceProviderId = this.selectedServicePlan?.serviceProviderModel?.serviceProviderId;
		const queryParams = new Map();
		this.serviceProviderService.get([serviceProviderId, 'ProfileImage'], queryParams).subscribe((result: any) => {
			this.profileImage = result.data.imageData
		});
	}

}
